(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 91811:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
}), 'FavoriteBorder');
exports.Z = _default;

/***/ }),

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js


function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js


const _excluded = ["className", "component"];








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 83965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardMedia_CardMedia; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardMedia/cardMediaClasses.js


function getCardMediaUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardMedia', slot);
}
const cardMediaClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardMedia', ['root', 'media', 'img']);
/* harmony default export */ var CardMedia_cardMediaClasses = ((/* unused pure expression or super */ null && (cardMediaClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js


const _excluded = ["children", "className", "component", "image", "src", "style"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    isMediaComponent,
    isImageComponent
  } = ownerState;
  const slots = {
    root: ['root', isMediaComponent && 'media', isImageComponent && 'img']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardMediaUtilityClass, classes);
};
const CardMediaRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardMedia',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      isMediaComponent,
      isImageComponent
    } = ownerState;
    return [styles.root, isMediaComponent && styles.media, isImageComponent && styles.img];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'block',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
}, ownerState.isMediaComponent && {
  width: '100%'
}, ownerState.isImageComponent && {
  // ⚠️ object-fit is not supported by IE11.
  objectFit: 'cover'
}));
const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
const IMAGE_COMPONENTS = ['picture', 'img'];
const CardMedia = /*#__PURE__*/react.forwardRef(function CardMedia(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardMedia'
  });
  const {
      children,
      className,
      component = 'div',
      image,
      src,
      style
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
  const composedStyle = !isMediaComponent && image ? (0,esm_extends/* default */.Z)({
    backgroundImage: `url("${image}")`
  }, style) : style;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    isMediaComponent,
    isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardMediaRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    as: component,
    role: !isMediaComponent && image ? 'img' : undefined,
    ref: ref,
    style: composedStyle,
    ownerState: ownerState,
    src: isMediaComponent ? image || src : undefined
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CardMedia_CardMedia = (CardMedia);

/***/ }),

/***/ 99690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12963);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);





function MyBreadcrumbs(_ref) {
  var routeList = _ref.routeList,
      inverted = _ref.inverted,
      t = _ref.t;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    "aria-label": "breadcrumb",
    separator: "\u203A",
    sx: {
      '.MuiBreadcrumbs-separator': {
        color: 'white'
      }
    },
    children: routeList.map(function (route) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        underline: "hover",
        color: inverted ? route.isActive ? '#DDDDDD' : 'white' : route.isActive ? 'text.primary' : "inherit",
        href: route.href,
        children: !!t ? t("home:".concat(route.label)) : route.label
      }, route.label);
    })
  });
}

/***/ }),

/***/ 8930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93946);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94054);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33841);
/* harmony import */ var _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37058);
/* harmony import */ var _mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87109);
/* harmony import */ var _mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42761);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);











function MyInput(_ref) {
  var inputName = _ref.inputName,
      placeHolder = _ref.placeHolder,
      value = _ref.value,
      onChange = _ref.onChange,
      handleClick = _ref.handleClick,
      margin = _ref.margin,
      onKeyDown = _ref.onKeyDown;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    style: {
      marginTop: margin ? 10 : null
    },
    sx: {
      width: '25ch'
    },
    variant: "outlined",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      size: "small",
      style: {
        fontFamily: 'Montserrat',
        fontWeight: 500
      },
      htmlFor: inputName,
      children: placeHolder
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      size: "small",
      id: inputName,
      type: 'text',
      value: value,
      onChange: onChange,
      onKeyDown: function onKeyDown(ev) {
        if (ev.key === 'Enter') {
          // Do code here
          handleClick();
          ev.preventDefault();
        }
      },
      endAdornment: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        position: "end",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          "aria-label": "toggle password visibility",
          onClick: handleClick // onMouseDown={handleMouseDownPassword}
          ,
          edge: "end",
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        })
      }),
      label: placeHolder
    })]
  });
}

/***/ }),

/***/ 33260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10315);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30431);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90296);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80819);
/* harmony import */ var components_MyInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8930);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);









var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function (theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "row",
      padding: 0
    },
    table: {
      "&:last-child": {
        // backgroundColor: 'red',
        alignSelf: "flex-end !important",
        justifyContent: 'flex-end',
        display: 'flex'
      }
    }
  };
});
function MyList(props) {
  var classes = useStyles();
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var sort = props.sort,
      setSort = props.setSort,
      SORT_OPTIONS = props.SORT_OPTIONS,
      dataList = props.dataList,
      title = props.title,
      subTitle = props.subTitle,
      name = props.name,
      showAll = props.showAll,
      showSearchAndSort = props.showSearchAndSort,
      ItemComponent = props.itemComponent,
      baseUrl = props.baseUrl,
      t = props.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      searchInput = _useState[0],
      setSearchInput = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(dataList),
      localList = _useState2[0],
      setLocalList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMobile = _useState3[0],
      setIsMobile = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var onChange = function onChange(e) {
    setSearchInput(e.target.value);
  };

  var onClickFind = function onClickFind() {
    var res = dataList.filter(function (item) {
      return item.name.toLowerCase().includes(searchInput.toLowerCase());
    });
    console.log('searching! : ', searchInput, res, res.length);
    setLocalList(res);
  };

  var handleSortChange = function handleSortChange(event) {
    setSort(event.target.value);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setLocalList(dataList);
    setLoaded(true);
  }, [dataList]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.checkMobile)());
    }
  }, [loaded]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
      style: {
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h1", {
        style: {
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 700,
          textDecoration: 'unset'
        },
        children: title
      }), showAll ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        href: "/brands/".concat(name),
        style: {
          alignSelf: 'flex-end',
          display: 'flex',
          textDecoration: 'none'
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h3", {
          style: {
            fontSize: 14,
            fontWeight: 400,
            color: '#7C7C7C',
            fontFamily: 'Montserrat'
          },
          children: !!t ? t('button_showall') : 'Show All'
        })
      }) : subTitle === undefined ? null : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h3", {
        style: {
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 400,
          color: '#7C7C7C',
          fontFamily: 'Montserrat'
        },
        children: subTitle
      }), showSearchAndSort ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: "w-full h-full flex flex-row items-center justify-between",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          value: sort,
          onChange: handleSortChange,
          size: 'small',
          className: "w-52 text-sm bg-white",
          defaultValue: !!t ? t("home:".concat(SORT_OPTIONS[0].label)) : SORT_OPTIONS[0].label,
          children: SORT_OPTIONS.map(function (option) {
            return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              value: option,
              children: !!t ? t("home:".concat(option.label)) : option.label
            }, option.label);
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(components_MyInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          onChange: onChange,
          value: searchInput,
          handleClick: onClickFind,
          placeHolder: !!t ? t('home:findAnItem') : 'keyword',
          margin: false
        })]
      }) : null]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      className: "flex-grow",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        className: isMobile ? "flex grid grid-cols-1 items-center justify-center" : "grid grid-cols-4 gap-3",
        children: localList.map(function (item) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ItemComponent, {
            data: item,
            width: 262,
            margin: true,
            baseUrl: baseUrl === '/services/' ? "".concat(baseUrl, "listing") : baseUrl === '/products/' ? "".concat(baseUrl).concat(item.category.slug) : "".concat(baseUrl)
          }, item.name);
        })
      })
    })]
  });
}

/***/ }),

/***/ 1478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemSlider; }
/* harmony export */ });
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faChevronRight__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64746);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faChevronLeft__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75334);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30719);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83321);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67814);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57731);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
















var Pagination = function Pagination() {
  var swiper = (0,swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .useSwiper */ .oc)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(swiper.isBeginning),
      isBeginning = _useState[0],
      setIsBeginning = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(swiper.isEnd),
      isEnd = _useState2[0],
      setIsEnd = _useState2[1];

  swiper.on('slideChange', function () {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  });

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isMobile = _useState3[0],
      setIsMobile = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.checkMobile)());
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
    className: isMobile ? "flex justify-end mt-7" : "flex justify-end mt-5",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      variant: 'text',
      size: 'medium',
      disabled: isBeginning,
      className: "min-w-0 mr-2 text-black hover:text-primary",
      onClick: function onClick() {
        return swiper.slidePrev();
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_pro_solid_svg_icons_faChevronLeft__WEBPACK_IMPORTED_MODULE_11__/* .faChevronLeft */ .A3
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      variant: 'text',
      size: 'medium',
      disabled: isEnd,
      className: "min-w-0 text-black hover:text-primary",
      onClick: function onClick() {
        return swiper.slideNext();
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_pro_solid_svg_icons_faChevronRight__WEBPACK_IMPORTED_MODULE_12__/* .faChevronRight */ ._t
      })
    })]
  });
};

function ItemSlider(_ref) {
  var title = _ref.title,
      items = _ref.items,
      href = _ref.href,
      render = _ref.render,
      _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? {
    700: {
      slidesPerView: 4,
      slidesPerGroup: 4
    }
  } : _ref$breakpoints;

  var _useTranslation2 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)(),
      t = _useTranslation2.t;

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__.checkMobile)());
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
      className: "flex items-center mb-4",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
        className: "font-semibold grow text-lg",
        children: title
      }), href && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        href: href,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("a", {
          children: t('home:button_showall')
        })
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
      loop: false,
      slidesPerView: isMobile ? 1 : 4,
      slidesPerGroup: isMobile ? 1 : 4,
      spaceBetween: 15,
      autoHeight: true,
      breakpoints: breakpoints,
      children: [items.map(function (item, i) {
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
          children: render(item)
        }, i);
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Pagination, {
        slot: "container-end"
      })]
    })]
  });
}

/***/ }),

/***/ 25654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrandCard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83965);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44267);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36111);
/* harmony import */ var _mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91811);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);








function BrandCard(_ref) {
  var item = _ref.data,
      className = _ref.className,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
      margin = _ref.margin;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(item.followers),
      follower = _useState[0],
      setFollower = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(item.liked),
      liked = _useState2[0],
      setLiked = _useState2[1];

  var toggleLiked = function toggleLiked() {
    setLiked(!liked);
    setFollower(liked ? follower - 1 : follower + 1);
  };

  var handleImageError = function handleImageError(e) {
    e.target.onerror = null;
    e.target.src = "https://dummyimage.com/640x1:1/eeeeee/333333&text=".concat(item.name);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {// console.log('item: ', item)
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    onMouseEnter: onMouseEnter,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(row && 'flex', className, 'cursor-pointer'),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/brands/".concat(encodeURIComponent(item.slug), "/").concat(item.id),
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "h-340 mb-5 cursor-pointer, shadow-md rounded overflow-hidden p-4",
        sx: {
          marginRight: margin === true ? 5 : 0 // maxWidth: 280,
          // margin: "0 auto",
          // padding: "0.1em",

        },
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
          style: {
            position: 'relative'
          },
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            component: "img",
            sx: {
              height: 262,
              padding: "1em 1em 0 1em",
              objectFit: 'contain'
            },
            image: item.logo,
            alt: encodeURIComponent(item.slug),
            onError: handleImageError
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
            onClick: function onClick() {
              return toggleLiked();
            },
            style: {
              position: "absolute",
              top: 10,
              left: "90%",
              transform: "translateX(-50%)",
              cursor: 'pointer'
            },
            children: liked === true ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            sx: {
              height: 50,
              fontSize: 16,
              fontWeight: 700,
              color: 'black',
              fontFamily: 'Montserrat'
            },
            children: item.name
          })
        })]
      })
    })
  });
}

/***/ }),

/***/ 11074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LocationCard; }
/* harmony export */ });
/* harmony import */ var components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5503);
/* harmony import */ var components_Rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4656);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_utils_calcOpenNow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95271);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);








function LocationCard(_ref) {
  var location = _ref.data,
      className = _ref.className,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
      showDetails = _ref.showDetails,
      setSelectedStore = _ref.setSelectedStore,
      t = _ref.t,
      i18n = _ref.i18n;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(undefined),
      openNow = _useState[0],
      setOpenNow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('LocationName'),
      name = _useState2[0],
      setName = _useState2[1];

  var init = function init() {
    if (!!t && location.timeZone !== '') {
      var _calcOpenNow = (0,lib_utils_calcOpenNow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(location.business_hours, location.timezone),
          isOpen = _calcOpenNow.isOpen,
          closeTime = _calcOpenNow.closeTime;

      setOpenNow(isOpen ? "".concat(t('home:map_openUntil'), " ").concat(closeTime) : t('home:map_closed'));
    } else {
      setOpenNow('Closed');
    }

    if (location.slug !== '') {
      setName(location.slug);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    init();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    init();
  }, [t]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
    onClick: function onClick() {
      if (setSelectedStore) {
        setSelectedStore(location);
      }
    },
    onMouseEnter: onMouseEnter,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([row && 'flex', 'shadow-md rounded overflow-hidden p-4'], className),
    children: [showDetails ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(["relative after:content-[''] after:block", row ? 'after:pb-[100%] w-32' : 'after:pb-[56.25%] mb-4']),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        src: location.avatar_url,
        alt: location.name,
        className: "object-contain transition hover:brightness-105 cursor-pointer"
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
      href: "/stores/".concat(encodeURIComponent(name), "/").concat(location.id),
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(["relative after:content-[''] after:block", row ? 'after:pb-[100%] w-32' : 'after:pb-[56.25%] mb-4']),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          src: location.avatar_url,
          alt: location.name,
          className: "object-contain transition hover:brightness-105 cursor-pointer"
        })
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      className: "px-4",
      children: [showDetails ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("h4", {
          className: "font-bold text-base mb-2 ",
          children: location.name
        })
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/stores/".concat(encodeURIComponent(name), "/").concat(location.id),
        passHref: true,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("h4", {
            className: "font-bold text-base mb-2 min-h-[50px]",
            children: location.name
          })
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        className: "flex flex-nowrap items-center mb-2",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
          className: "text-xs mr-2",
          children: location.rating.toFixed(1)
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_Rating__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          value: location.rating || 5,
          precision: 0.5,
          readOnly: true,
          className: 'mr-2'
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
          className: "text-xs",
          children: ["(", location.reviews_count, ")"]
        })]
      }), location.has_curbside_pickup ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        className: "text-sm text-primary-dark font-semibold mb-1",
        children: !!t ? t('home:map_pickupAvailable') : ''
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        className: "mb-1 min-h-[20px]"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        className: "text-sm mb-1",
        children: openNow
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        className: "text-sm",
        children: [!!location.distance ? location.distance.toFixed(1) : '--', "km"]
      })]
    })]
  });
}

/***/ }),

/***/ 81125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BrandLayout; }
});

// UNUSED EXPORTS: getServerSideProps

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBadge.js
var faBadge = __webpack_require__(88172);
// EXTERNAL MODULE: ./components/blocks/Wrapper.js
var Wrapper = __webpack_require__(80819);
// EXTERNAL MODULE: ./components/blocks/Container.js
var Container = __webpack_require__(75046);
// EXTERNAL MODULE: ./components/ImageWithFallback.js
var ImageWithFallback = __webpack_require__(5503);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MyBreadcrumbs.js
var MyBreadcrumbs = __webpack_require__(99690);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./components/Rating.js
var Rating = __webpack_require__(4656);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Favorite.js
var Favorite = __webpack_require__(36111);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/brands/BrandHeader.js













function BrandHeader() {
  var brand = (0,es/* useSelector */.v9)(function (state) {
    return state.brand.brand;
  }); // console.log('at header: ', brand)

  var BREAD_ROUTE = [{
    label: 'Home',
    href: '/',
    isActive: false
  }, {
    label: 'Brands',
    href: '/brands/discovery',
    isActive: false
  }, {
    label: brand.name,
    href: "/brands/".concat(brand.slug),
    isActive: true
  }];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
    className: 'p-0 relative',
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWithFallback/* default */.Z, {
      className: 'absolute inset-0 object-cover h-400',
      src: brand.hero,
      alt: brand.name
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
      className: 'relative z-1 w-[86.667%] pt-10',
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyBreadcrumbs/* default */.Z, {
        routeList: BREAD_ROUTE,
        inverted: true
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "flex flex-row items-center mt-5",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: "relative w-[100px] after:content-[''] after:block after:pb-[100%] mr-5",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWithFallback/* default */.Z, {
            src: brand.logo,
            alt: brand.name,
            className: 'object-contain',
            fallback: {
              size: '640x1:1'
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: "flex-column ",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex flex-row items-center text-white justify-center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
              className: "text-2xl font-bold mb-2 text-white",
              children: brand.name
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "mb-2 w-10 mr-1 text-center text-blue-400 self-auto justify-self-center\t",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                icon: faBadge/* faBadge */.mA
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex flex-nowrap items-center mb-4 text-white",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Favorite/* default */.Z, {
              className: "mr-1",
              sx: {
                width: 20
              }
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "text-xs mr-2 font-medium",
              children: "".concat(brand.followers, " followers")
            })]
          })]
        })]
      })]
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/store.js + 1 modules
var store = __webpack_require__(18820);
// EXTERNAL MODULE: ./lib/features/brandSlice.js
var brandSlice = __webpack_require__(77078);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(3580);
;// CONCATENATED MODULE: ./layouts/BrandLayout.js
















var getServerSideProps = store/* wrapper.getServerSideProps */.Y.getServerSideProps(function (store) {
  return /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
      var query, _query$page, page;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = _ref.query;
              _query$page = query.page, page = _query$page === void 0 ? 1 : _query$page;
              return _context.abrupt("return", {
                props: {
                  page: page
                }
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
});

var Tab = function Tab(_ref3) {
  var href = _ref3.href,
      active = _ref3.active,
      children = _ref3.children,
      className = _ref3.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: href,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)('border-t-3 border-b-3 border-transparent py-3 px-5 -m-[1px]', {
          'border-b-primary font-bold': active
        }, className),
        children: children
      })
    })
  });
};

function BrandLayout(_ref4) {
  var children = _ref4.children;
  var router = (0,next_router.useRouter)();
  var slug = router.query.brandSlug;
  var id = router.query.id;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      loaded = _useState[0],
      setLoaded = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0,react.useEffect)(function () {
    setLoaded(true);
  }, []);
  (0,react.useEffect)(function () {
    if (loaded) {
      setIsMobile(helper.checkMobile);
    }
  }, [loaded]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandHeader, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      className: 'py-0 border-t border-b',
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        className: isMobile ? 'flex overflow-scroll' : 'flex',
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          href: "/brands/".concat(slug, "/").concat(id),
          active: router.pathname === '/brands/[slug]/[id]',
          children: t('home:brandsDiscovery')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          href: "/brands/".concat(slug, "/").concat(id, "/products"),
          active: router.pathname === '/brands/[brandSlug]/[id]/products',
          children: t('home:brandsFeaturedProducts')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          href: "/brands/".concat(slug, "/").concat(id, "/services"),
          active: router.pathname === '/brands/[brandSlug]/[id]/services',
          children: t('home:brandsFeaturedServices')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          href: "/brands/".concat(slug, "/").concat(id, "/stores"),
          active: router.pathname === '/brands/[brandSlug]/[id]/stores',
          children: t('home:brandsFeaturedStores')
        })]
      })
    }), children]
  });
}

/***/ }),

/***/ 95271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ calcOpenNow; }
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30120);

function calcOpenNow(hours, timezone) {
  var zonedNow = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.now */ .ou.now().setZone(timezone);
  var tempHour = hours[zonedNow.weekdayLong.toLowerCase()];

  if (tempHour !== undefined) {
    var open = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromFormat */ .ou.fromFormat(tempHour.open, 'hh:mma', {
      zone: timezone
    });
    var close = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromFormat */ .ou.fromFormat(tempHour.close, 'hh:mma', {
      zone: timezone
    });
    return {
      isOpen: open < zonedNow && zonedNow < close,
      openTime: open.toFormat('hh:mm a').toUpperCase(),
      closeTime: close.toFormat('hh:mm a').toUpperCase()
    };
  } else {
    return {
      isOpen: false,
      openTime: '',
      closeTime: ''
    };
  }
}

/***/ }),

/***/ 56173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Services; }
/* harmony export */ });
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87607);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75046);
/* harmony import */ var layouts_BrandLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41248);
/* harmony import */ var components_cards_ProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34101);
/* harmony import */ var components_MyList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33260);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67814);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _data_config_json__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56513);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57731);
/* harmony import */ var lib_features_productSlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21475);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var components_views_ProductListing__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74190);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35944);

















var SORT_OPTIONS = _data_config_json__WEBPACK_IMPORTED_MODULE_8__/* .product.sort */ .O7.DY;
var PRICE_RANGES = _data_config_json__WEBPACK_IMPORTED_MODULE_8__/* .product.priceRange */ .O7.GD;
var __N_SSP = true;
function Services(props) {
  var _page = props.page,
      _filter = props.filter,
      _sort = props.sort,
      deals = props.allDeals,
      CATEGORIES = props.CATEGORIES;
  var brand = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function (state) {
    return state.brand.brand;
  });
  var services = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function (state) {
    return state.product.services;
  });
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      filteredServices = _useState[0],
      setFilteredServices = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (services && brand.services) {
      var tempFilteredServices;

      if (brand.services.includes(',')) {
        tempFilteredServices = services.filter(function (item) {
          return brand.services.split(', ').includes(item.id);
        });
      } else {
        tempFilteredServices = services.filter(function (item) {
          return brand.services === item.id;
        });
      }

      setFilteredServices(tempFilteredServices);
    }

    setLoaded(true);
  }, [services]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (services.length === 1 && services[0].id === 0) {
      dispatch((0,lib_features_productSlice__WEBPACK_IMPORTED_MODULE_10__/* .getPaginatedServicesThunk */ .dl)({
        _page: _page,
        _filter: _filter,
        _sort: _sort
      }));
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {}, [filteredServices]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
      children: loaded ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(components_views_ProductListing__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        _filter: _filter,
        _page: _page,
        _sort: _sort,
        products: filteredServices,
        deals: deals,
        brands: [],
        type: 'Brand_Service',
        categories: CATEGORIES,
        baseUrl: "/services/listing/"
      }) : null
    })
  });
}

Services.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(layouts_BrandLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: page
    })
  });
};

/***/ }),

/***/ 8685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faChevronRight.js
var faChevronRight = __webpack_require__(64746);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./layouts/Default.js + 5 modules
var Default = __webpack_require__(87607);
// EXTERNAL MODULE: ./components/blocks/Wrapper.js
var Wrapper = __webpack_require__(80819);
// EXTERNAL MODULE: ./components/blocks/Container.js
var Container = __webpack_require__(75046);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/blocks/HeroSlider.js


var _excluded = ["id", "slides", "brightness", "useNavigation", "usePagination", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












function HeroSlider(_ref) {
  var id = _ref.id,
      slides = _ref.slides,
      brightness = _ref.brightness,
      _ref$useNavigation = _ref.useNavigation,
      useNavigation = _ref$useNavigation === void 0 ? true : _ref$useNavigation,
      _ref$usePagination = _ref.usePagination,
      usePagination = _ref$usePagination === void 0 ? true : _ref$usePagination,
      className = _ref.className,
      swiperProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
    className: (0,clsx_m/* default */.Z)(className, 'h-60vh]', 'py-0'),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
      modules: [swiper_esm/* Navigation */.W_, swiper_esm/* Pagination */.tl],
      navigation: useNavigation,
      pagination: usePagination ? {
        clickable: true
      } : false,
      id: id,
      className: (0,clsx_m/* default */.Z)('h-full')
    }, swiperProps), {}, {
      children: slides.map(function (slide, i) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(swiper_react/* SwiperSlide */.o5, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
            className: 'object-cover',
            style: {
              filter: "brightness(".concat(brightness, ")")
            },
            layout: 'fill',
            src: slide.image,
            alt: ""
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
            className: "relative h-full",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
              className: "h-full",
              children: slide.content
            })
          })]
        }, i);
      })
    }))
  });
}
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./components/blocks/ItemSlider.js
var ItemSlider = __webpack_require__(1478);
// EXTERNAL MODULE: ./components/cards/LocationCard.js
var LocationCard = __webpack_require__(11074);
// EXTERNAL MODULE: ./components/cards/BrandCard.js
var BrandCard = __webpack_require__(25654);
// EXTERNAL MODULE: ./components/cards/ProductCard.js + 1 modules
var ProductCard = __webpack_require__(34101);
// EXTERNAL MODULE: ./components/ImageWithFallback.js
var ImageWithFallback = __webpack_require__(5503);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(3580);
;// CONCATENATED MODULE: ./components/cards/ArticleCard.js





function ArticleCard(_ref) {
  var article = _ref.data;
  var timestamp = new Date(article.date + 'z').toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    onClick: function onClick() {
      window.open(article.link, '_blank');
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "relative pb-[66.25%] h-0 mb-4",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWithFallback/* default */.Z, {
        src: article.featureImg,
        alt: article.title,
        className: "object-cover"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "px-4 mb-2",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
        className: "font-bold text-base mb-2",
        children: article.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "text-xs font-semibold",
        children: timestamp
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: "flex justify-end flex-wrap",
      children: article.tags.map(function (tag) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
          label: tag,
          color: 'primary',
          variant: 'outlined',
          size: 'small',
          className: 'border-[1.5px] rounded-lg font-semibold mt-2 ml-2'
        }, tag);
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
// EXTERNAL MODULE: ./pages/brands/[brandSlug]/[id]/services.js
var services = __webpack_require__(56173);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/index.js

























var __N_SSP = true;
function Home(props) {
  var stores = props.stores,
      learnArticles = props.learnArticles,
      newsArticles = props.newsArticles,
      locale = props.locale;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var topBrands = (0,es/* useSelector */.v9)(function (state) {
    return state.brand.topBrands;
  });
  var topProducts = (0,es/* useSelector */.v9)(function (state) {
    return state.product.topProducts;
  });
  var topServices = (0,es/* useSelector */.v9)(function (state) {
    return state.product.topServices;
  });
  var topLocations = (0,es/* useSelector */.v9)(function (state) {
    return state.map.topLocations;
  });

  var _useState = (0,react.useState)([]),
      localProducts = _useState[0],
      setLocalProducts = _useState[1];

  var _useState2 = (0,react.useState)([]),
      localBrands = _useState2[0],
      setLocalBrands = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      localStores = _useState3[0],
      setLocalStores = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isMobile = _useState5[0],
      setIsMobile = _useState5[1];

  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    if (loaded) {
      setIsMobile(helper.checkMobile);
    }
  }, [loaded]);
  (0,react.useEffect)(function () {
    if (!!topBrands && topBrands.length > 0 && !!topProducts && topProducts.length > 0 && !!topLocations && topLocations.length > 0) {
      setLoaded(true);
    }

    if (!!topBrands && topBrands.length > 0) {
      var temp = (0,toConsumableArray/* default */.Z)(topBrands);

      var checkGrowTown = temp.find(function (item) {
        return item.id === '139';
      });
      var checkCabana = temp.find(function (item) {
        return item.id === '142';
      });
      var checkTokyo = temp.find(function (item) {
        return item.id === '143';
      });
      var growTown = {
        id: '139',
        description: 'Welcome to Growtown! Our mission is to bring unique products and ideas to the cannabis community. Whether we are blazing the trail with innovative never-before-seen products, or evolving your favourite legacy strain, it is our goal to curate a spectrum of accessible, quality products stemming from research, development, and community feedback. \n' + '\n' + '​\n' + '\n' + 'Through the celebration of major and minor cannabinoids and the excitement of exploring uncharted territories, we are committed to being more than just another brand of cannabis.',
        name: 'GrowTown',
        create_dt: '2023-03-16 02:35:57',
        social_link: '[{"platform":"Instagram","accountId":"growtowncannabis"}]',
        category: '',
        biz_type: 'PRODUCT',
        logo: 'https://damawish-files-bucket-dev.s3.us-east-1.amazonaws.com/7C0tobknlcIgFUUi9hkmV-Growtown%20Logo%20no%20Circle%20(3).png',
        hero: 'https://damawish-files-bucket-dev.s3.us-east-1.amazonaws.com/wt-PwiwInH9UZEt4DlHd7-51821678934100_.pic.jpg',
        profile_id: '49',
        sts: 'ACTIVE',
        public_viewable: 'N',
        promo_rank: '1',
        slug: 'GrowTown',
        bizType: 'PRODUCT',
        businessType: undefined,
        products: '',
        services: '',
        locations: '',
        liked: undefined,
        followers: undefined,
        deals: undefined,
        productsList: undefined,
        serviceList: undefined
      };
      var cabana = {
        __typename: 'Brand',
        id: '142',
        name: 'Canna Cabana',
        slug: 'Canna Cabana',
        description: 'Welcome to the blue skies and sunny shores of Canna Cabana. When we say we’re the real OGs, we mean it—for over 10 years, we’ve been smoking and toking and creating places for cannabis lovers of all kinds to gather, chat, and share their passion for the plant.\n' + '\n' + 'We began as Smoker’s Corner in Calgary, 2009. Back then, we were just a little head shop with big dreams of changing cannabis culture for the better. We knew that smokers deserved more than sketchy alleyways and dim basements. Stoner culture is vibrant, fun, and full of amazing people—and so we created a place that reflected us.\n' + '\n' + 'When legalization finally came, we wanted to bring that same vibe to selling cannabis (Man, sometimes we still can’t believe it’s finally legal. Someone pinch us?). Canna Cabana was created by and for people who love weed—love to smoke it, buy it, chat about it, and share it with their friends.\n' + '\n' + 'Want to check out a new vape, discover a new strain, get some advice from our experts, or stock up for a hazy weekend? Step on in to your local Canna Cabana–we built it for you!',
        businessType: 'STORE',
        category: '',
        logo: 'https://damawish-files-bucket-dev.s3.us-east-1.amazonaws.com/28qvMCz8XxFNnjcs1Bt-v-cannacabana-logo-color-01.png',
        hero: 'https://damawish-files-bucket-dev.s3.us-east-1.amazonaws.com/ZPqWkcBI7rHcLgAnDsHy3-lvlkUgnAQOSeoQSvJeXp_Canna-cabana-CP.avif',
        publicViewable: true,
        locations: '',
        products: '',
        services: '',
        liked: false,
        followers: 951,
        bizType: 'LOCATION'
      };
      var tokyoSmoke = {
        __typename: 'Brand',
        id: '143',
        name: 'Tokyo Smoke',
        slug: 'Tokyo Smoke',
        description: 'Tokyo Smoke is an award-winning, design focused, legal cannabis retailer. We believe that cannabis is good, and that your shopping experience should be nothing short of great.',
        businessType: 'PRODUCT',
        category: '',
        logo: 'https://damawish-files-bucket-dev.s3.us-east-1.amazonaws.com/bG45bXCupaCa92wShfv6k-Tokyo%20Smoke.jpg',
        hero: 'https://damawish-files-bucket-dev.s3.us-east-1.amazonaws.com/lx-yrgU1Ik9sXXdeTKsm1-61571692586161_.pic.jpg',
        publicViewable: false,
        locations: '',
        products: '',
        services: '',
        liked: false,
        followers: 191,
        bizType: 'LOCATION'
      };
      /** Hard fix brands missing **/

      if (!!checkGrowTown && checkGrowTown.name === '') {
        temp.splice(0, 1, growTown);
      }

      if (!!checkCabana && checkCabana.name === '') {
        temp.splice(1, 1, cabana);
      }

      if (!!checkTokyo && checkTokyo.name === '') {
        temp.splice(2, 1, tokyoSmoke);
      }

      setLocalBrands(temp);
    }

    if (!!topProducts && topProducts.length > 0) {
      setLocalProducts(topProducts);
    }

    if (!!topLocations && topLocations.length > 0) {
      setLocalStores(topLocations);
    }
  }, [topBrands, topProducts, topLocations, loaded]);
  (0,react.useEffect)(function () {// console.log('here are products: ', JSON.stringify(localProducts.slice(0, 3)))
    // console.log('here are services: ', JSON.stringify(services.slice(services.length - 3, services.length)))
    //
    // console.log('here are brands: ', JSON.stringify(localBrands.slice(0, 3)))
    // console.log('here are stores: ', JSON.stringify(localStores.slice(0, 3)))
  }, [localStores, localProducts, localBrands, services["default"]]);
  (0,react.useEffect)(function () {
    console.log('topBrands: ', topBrands);
  }, [topBrands]);
  var HeroSlides = [{
    image: __webpack_require__(68789),
    content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "drop-shadow-sm flex flex-col justify-center items-start h-full",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
        className: isMobile ? "text-6xl font-serif text-white mb-7" : "text-8xl font-serif text-white mb-7",
        children: t('home:findOut')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        className: "text-3xl font-semibold text-white mb-14",
        children: t('home:whatWeCanDo')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "https://damamap.com/6-benefits-of-cbd-oil/",
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            variant: 'contained',
            color: 'black',
            size: 'xl',
            className: "normal-case",
            endIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
              icon: faChevronRight/* faChevronRight */._t,
              className: "!h-3.5"
            }),
            children: t('home:hero_learn_more')
          })
        })
      })]
    })
  }, {
    image: __webpack_require__(83697),
    content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "drop-shadow-sm flex flex-col justify-center items-start h-full",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
        className: isMobile ? "uppercase text-6xl font-serif text-white mb-7" : "uppercase text-7xl font-serif text-white mb-7",
        children: t('home:trusted')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        className: "uppercase text-3xl font-semibold text-white mb-14",
        children: t('home:consultant')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "https://damamaps.com/services/listing/Cannabis License Experts/73",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            variant: 'contained',
            color: 'black',
            size: 'xl',
            className: "normal-case",
            endIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
              icon: faChevronRight/* faChevronRight */._t,
              className: "!h-3.5"
            }),
            children: t('home:getYourLicense')
          })
        })
      })]
    })
  }, {
    image: __webpack_require__(30341),
    content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "drop-shadow-sm flex flex-col justify-center items-start h-full",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h1", {
        className: isMobile ? "leading-tight text-4xl font-serif text-white mb-7" : "leading-tight text-5xl font-serif text-white mb-7",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          className: isMobile ? "text-4xl" : "text-6xl",
          children: t('home:grow')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), t('home:yourBusiness'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), t('home:withUs')]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        className: " text-3xl font-semibold text-white mb-14",
        children: t('home:listStore')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "https://damamap.com/en/list-your-stores/",
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            variant: 'contained',
            color: 'black',
            size: 'xl',
            className: "normal-case",
            endIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
              icon: faChevronRight/* faChevronRight */._t,
              className: "!h-3.5"
            }),
            children: t('home:hero_learn_more')
          })
        })
      })]
    })
  }];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
        children: "DaMaMaps | Home"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "keywords",
        content: "DaMaMaps, DaMawish, CBD, THC"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:title",
        lang: "en",
        content: "DaMaMaps | Home"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:title",
        lang: "zh-Hans",
        content: "\u5927\u9EBB\u5730\u56FE | \u5E26\u4F60\u63A2\u5BFB\u4E00\u4E2A\u795E\u79D8\u9886\u57DF\u7684\u751F\u6D3B\u65B9\u5F0F"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:image",
        content: "https://damawish-files-bucket-dev.s3.amazonaws.com/DaMaMaps_logo_transparent.png"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:description",
        lang: "en",
        content: "DaMaMaps.com is a cutting-edge cannabis technology and advertising company located in Toronto, Canada. As the first and foremost legal cannabis-related platform, we provide a comprehensive international marketplace, e-commerce services, and online social networking and communication platforms. Our website is currently available in English and Chinese versions, and we are now working towards launching versions in Japanese and Korean to broaden our global reach."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:description",
        lang: "zh-Hans",
        content: "\u5927\u9EBB\u5730\u56FEDaMaMaps.com\u662F\u5168\u7403\u534E\u4EBANo.1\u6700\u5927\u7684\u5927\u9EBB\u5A92\u4F53\u793E\u4EA4\u7535\u5546\u5E73\u53F0\u79D1\u6280\u516C\u53F8\uFF0C\u4F4D\u4E8E\u52A0\u62FF\u5927\u5B89\u5927\u7565\u7701\u591A\u4F26\u591A\u5E02\u3002\u6211\u4EEC\u4E3A\u534E\u4EBA\u793E\u533A\u63D0\u4F9B\u5728\u7EBF\u5408\u6CD5\u5927\u9EBB\u5E73\u53F0\uFF0C\u4E3A\u7528\u6237\u63D0\u4F9B\u67E5\u770B\uFF0C\u8BC4\u4EF7\u548C\u8BA8\u8BBA\u6240\u6709\u4E0E\u5927\u9EBB\u4EA7\u54C1\u6709\u5173\u7684\u5546\u5BB6, \u5F53\u5730\u836F\u623F\u4E0E\u76F8\u5173\u4FE1\u606F\u3002\u6211\u4EEC\u7684\u76EE\u6807\u662F\u5728\u6211\u4EEC\u7684\u5E73\u53F0\u4E0A\u4EE5\u63D0\u4F9B\u9AD8\u8D28\u91CF\u7684\u6587\u7AE0\u4E0E\u76F8\u5E94\u7814\u7A76\uFF0C\u5C24\u5176\u662F\u534E\u4EBA\u793E\u533A\uFF0C\u8BA9\u5927\u4F17\u5BA2\u89C2\u4E86\u89E3\u5927\u9EBB\u4E0E\u6C49\u9EBB\u3002\u6B64\u5916\uFF0C\u6211\u4EEC\u6709\u4E00\u4E2A\u5F3A\u5927\u7684\u4E2D\u6587\u793E\u4EA4\u7F51\u7EDC\u5E73\u53F0\uFF0C\u5BA2\u6237\u53EF\u4EE5\u5229\u7528\u8BE5\u5E73\u53F0\u8FDB\u884C\u4EA4\u6D41\uFF0C\u4E0E\u5176\u4ED6\u7528\u6237\u4E92\u52A8\u5E76\u5206\u4EAB\u4ED6\u4EEC\u7684\u89C1\u89E3\u3002"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:url",
        content: "https://damamaps.com"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "twitter:card",
        content: "https://damawish-files-bucket-dev.s3.amazonaws.com/DaMaMaps_logo_transparent.png"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroSlider, {
      id: "home-hero-slider",
      className: "!h-[40vh] max-h-[400px]",
      slides: HeroSlides,
      brightness: 0.9,
      loop: true
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: loaded ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSlider/* default */.Z, {
          title: t('home:home_featuredstores'),
          items: localStores,
          href: "/map",
          render: function render(item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationCard/* default */.Z, {
              data: item,
              t: t,
              i18n: i18n
            });
          }
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: t('home:loading')
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: loaded ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSlider/* default */.Z, {
          title: t('home:home_featuredbrands'),
          items: localBrands,
          href: "/brands/discovery",
          render: function render(item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandCard/* default */.Z, {
              data: item
            });
          }
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: t('home:loading')
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: loaded ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSlider/* default */.Z, {
          title: t('home:home_featuredproducts'),
          items: localProducts,
          href: "/products",
          render: function render(item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductCard/* default */.Z, {
              data: item,
              type: 'Product'
            });
          }
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: t('home:loading')
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
      className: "pt-6",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
          className: "text-2xl font-bold mb-6",
          children: t('home:home_newsandeducation')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSlider/* default */.Z, {
          title: t('home:learn_cannabis101'),
          items: learnArticles,
          href: "https://damamap.com/law/",
          render: function render(item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleCard, {
              data: item
            });
          }
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        className: "mt-16",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSlider/* default */.Z, {
          title: t('home:news'),
          items: newsArticles,
          href: "https://damamap.com/news/",
          render: function render(item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleCard, {
              data: item
            });
          }
        })
      })]
    })]
  });
}

Home.getLayout = function getLayout(page) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Default/* default */.Z, {
    children: page
  });
};

/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8685);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero-img-1-2.80c75b91.png","height":610,"width":1440,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAIVBMVEXyeRz7jC33gyPUXw/kbBPqjDjfaRfxfSPocRfGcC/CbS2mmkBaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIklEQVR4nAXBgQEAIAjDsI4JTP8/2AQP7xLjlFQcZtWtygcFUwBgtQN/hAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 83697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero-img-1-3.fde6768a.png","height":610,"width":1440,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAKlBMVEUuSwVcdCNcZjU+WwhleDFDVxp1ji57hk9gfSFNaRZCTRljbEBIbASJj2ianDrqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGPgYuJmYmRhYmVg4WVnY2Tl4GRgYGZkY2bgYQAABqEAdE6K7msAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 30341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero-img-1-4.e244e352.png","height":610,"width":1440,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAM1BMVEVcR0xZV41CMSt3VktQP1lRddhlUV5VQjc5JzxINVNpaJJDLkpaTW5PY7NWUYuIbl9DcekrnNs8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGPgYGHmE2Dl5GBg4WFg5OVi42Zg52diYGBn4AQACZwApZs4DwwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,196,2531,120,2435,6694,3787,5838,7918,7607,4190,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);